import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { RadioButton } from '@/components/radio-button';
import {
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  description: string;
  disabled: boolean;
  frequency: string;
  onSelectAutoPaySetting: (value: string) => void;
  rowStyle: StyleProp<ViewStyle>;
  selected: boolean;
  uuid: string;
}

export const AutoPaySettingRow: React.FC<Props> = ({
  description,
  disabled,
  frequency,
  onSelectAutoPaySetting,
  rowStyle,
  selected,
  uuid,
}) => {
  const [styles] = useStyles();

  return (
    <TouchableOpacity
      accessibilityRole="radio"
      accessible
      activeOpacity={1}
      aria-selected={selected}
      disabled={disabled}
      onPress={() => {
        if (!selected) {
          onSelectAutoPaySetting(uuid);
        }
      }}
      testID={`autopay-setting-${uuid}`}
    >
      <View style={[styles.autoPayOptionRow, rowStyle]}>
        <View style={[styles.autoPayOptionTextContainer]}>
          <Text style={[styles.autoPayOptionFrequency]}>{frequency}</Text>
          <Text style={[styles.autoPayOptionDescription]}>{description}</Text>
        </View>
        {!disabled && <RadioButton selected={selected} />}
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  autoPayOptionDescription: {
    ...TYPOGRAPHY.listSubtitle,
    color: theme.colors.inactiveText,
    lineHeight: 21,
    paddingTop: 8,
  },
  autoPayOptionFrequency: {
    ...TYPOGRAPHY.listTitle,
    fontWeight: '600',
    lineHeight: 20,
  },
  autoPayOptionRow: {
    borderBottomWidth: 1,
    borderColor: theme.sk.color.divider.default,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 16,
  },
  autoPayOptionTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 16,
  },
}));
